import './styles.css';
import React, { Children } from 'react';
import PropTypes from 'prop-types';

const InputGroup = ({ children }) => {
  const arrayChildren = Children.toArray(children);

  return (
    <div className="zedoc-input-group">
      {Children.map(arrayChildren, (child) => {
        const isButton = child.props.htmlType === 'button';
        const { noGrow } = child.props.inputGroupChildProps || {};

        return (
          <div
            className={`zedoc-input-group__item-container ${
              isButton || noGrow ? '' : 'flex-1'
            }`}
          >
            {child}
          </div>
        );
      })}
    </div>
  );
};

InputGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InputGroup;
